import React from "react";
import { Link } from "react-router-dom";

const LayoutInProgress = () => {
	return (
		<div className="inprogress">
			<h1>Blog comming soon...</h1>
			<p>You can kwow a little about me in </p>
			<Link to="/" className="btn fill green">
				About me
			</Link>
		</div>
	);
};

export default LayoutInProgress;
